import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './index.scss';

const RadioButton = ({checked, className, disabled, label, name, onChange}) => {
  return (
    <div className={classNames('RadioButton', className)}>
      <input
        checked={checked}
        disabled={disabled}
        name={name}
        onChange={onChange}
        type={'radio'}
      />
      <div className={'RadioButton--Mark'} />
      {label}
    </div>
  );
};

RadioButton.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

RadioButton.defaultProps = {
  checked: false,
  className: '',
  disabled: false,
  name: '',
};

export default RadioButton;
